
import { IVehicle } from '@interfaces/vehicle.interface';
import { createAction, props } from '@ngrx/store';


enum VehicleActionType {
  Load = '[Vehicle Component] Load',

  getAll = '[Vehicle Component] Search Vehicle',
  getAllSuccess = '[Vehicle Component] Search Vehicle Success',

  getByLicensePlate = '[Vehicle Component] Search Vehicle ByLicense Plate',
  getByLicensePlateSuccess = '[Vehicle Component] Search Vehicle Success',

  update = '[Vehicle Component] Update Vehicle',
  updateSuccess = '[Vehicle Component] Update Vehicle',

  create = '[Vehicle Component] Create Vehicle',
  createSuccess = '[Vehicle Component] Create Vehicle success',

  reset = '[Vehicle Component]  reset flags store',
  error = '[Vehicle Component]  oops there were some errors',

  resetVehicle = '[Vehicle Component]  reset vehicle store',
  resetVehicleSuccess = '[Vehicle Component]  reset vehicle store success',
}

const load = createAction(VehicleActionType.Load);

const getAll = createAction(
  VehicleActionType.getAll
);
const getAllSuccess = createAction(
  VehicleActionType.getAllSuccess,
  props<{ vehiclesList: IVehicle }>()
);
const create = createAction(
  VehicleActionType.create,
  props<{ vehicle: IVehicle }>()
);

const createSuccess = createAction(
  VehicleActionType.createSuccess,
  props<{ vehicle: IVehicle }>()
);

const getByLicensePlate = createAction(
  VehicleActionType.getByLicensePlate,
  props<{ licensePlate: string }>()
);


const getByLicensePlateSuccess = createAction(
  VehicleActionType.getByLicensePlateSuccess,
  props<{ vehicle: IVehicle }>()
);
const error = createAction(
  VehicleActionType.error,
  props<{ error: any }>()
);
const reset = createAction(
  VehicleActionType.reset,
);

const resetVehicle = createAction(
  VehicleActionType.resetVehicle
);

export const VehicleActions = {
  getAll,
  getAllSuccess,
  getByLicensePlate,
  getByLicensePlateSuccess,
  reset,
  resetVehicle,
  
  create,
  createSuccess,
  error
}
